import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FicScreenRef } from '../fic-screen-injecotors';
import { FicScreenRefModel } from '../fic-screen-ref';

@Component({
    selector: 'fic-screen-btn-close',
    template: ` <button mat-icon-button (click)="screenRef.close()">
        <mat-icon class="fa fa-chevron-left"></mat-icon>
    </button>`,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fic-screen-btn-close.component.scss'],
    host: { class: 'fic-screen-btn-close' },
    standalone: false,
})
export class FicScreenBtnCloseComponent {
    constructor(@Inject(FicScreenRef) public screenRef: FicScreenRefModel<any, any>) {}
}
